import React, { useEffect } from 'react';
import '../styles/CaseStudies.css';
import { handleLinkClick } from '../utils/deviceUtils';
import images from '../assets/index';

const caseStudiesData = [
    {
        title: "Building a Trusted Data Foundation for Financial Services",
        image: images.newcase1,
        to: "/case-studies/financial-services",
    },
    {
        title: "Modernizing Compliance & Reporting with Data at Scale",
        image: images.newcase2,
        to: "/case-studies/banking",
    },
    {
        title: "Unified Data for Smarter Insurance Decisions",
        image: images.newcase3,
        to: "/case-studies/insurance",
    },
    {
        title: "A Single Customer View for Better Airline Experiences",
        image: images.newcase4,
        to: "/case-studies/airline",
    },
];

const CaseStudiesPage = () => {

    useEffect(() => {
        document.title = "Case Studies | Datamatics Consulting";
    }, []);
    return (
        <div className="cs-main-page">

            {/* Hero Banner */}
            <section className="cs-main-hero">
                <div className="hero-overlay">
                    <div className="hero-content">
                        <h1 className="hero-title-cs">CASE STUDIES</h1>
                        <p className="hero-subtitle-cs">Driving Digital transformation across top banks, insurers, financial institutions,<br />and airlines with trusted, scalable data solutions.</p>
                    </div>
                </div>
            </section>

            {/* Title Section */}
            <section className="cs-title-section">
                <div className="subservice-title-wrapper-sub-cs">
                    <div className="purple-line-sub"></div>
                    <h2>Datamatics Consulting – Case Studies</h2>
                </div>
                <div className="subservice-title-wrapper-sub-cs mt-5 mobile-only">
                    <div className="purple-line-sub"></div>
                    <h3>Our Latest Projects</h3>
                </div>
            </section>

            {/* Case Studies 3 Cards */}
            <section className="case-studies-section-cs container">
                <div className="case-studies-grid-cs">
                    {caseStudiesData.slice(0, 3).map((study, index) => (
                        <div
                            key={index}
                            className="case-study-card-cs"
                            onClick={() => handleLinkClick(study.to)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="case-study-image-wrapper-cs">
                                <img src={study.image} alt={study.title} />
                            </div>
                            <h3 className="case-study-title-cs">{study.title}</h3>
                            <a href={study.to} className="case-study-read-more-cs" onClick={(e) => { e.preventDefault(); handleLinkClick(study.to); }}>
                                Read More →
                            </a>
                        </div>
                    ))}
                </div>
            </section>

            {/* Bottom Banner */}
            <section className="bottom-banner-sub-cs">
                <img src={images.code2} alt="Future of Data" />
                <div className="bottom-banner-overlay-sub">
                    <h2>The Future doesn't run on Code — It runs on DATA</h2>
                </div>
            </section>
        </div>
    );
};

export default CaseStudiesPage;